export default __webpack_public_path__ + "userNominations.html";